/**
 * @generated SignedSource<<4df7c297b49260138292153459fcd81d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type IssueTable_rankField$data = {
  readonly " $fragmentSpreads": FragmentRefs<"GroupTableBody_rankField" | "TableBody_rankField">;
  readonly " $fragmentType": "IssueTable_rankField";
};
export type IssueTable_rankField$key = {
  readonly " $data"?: IssueTable_rankField$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueTable_rankField">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "IssueTable_rankField",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "TableBody_rankField"
    },
    {
      "kind": "FragmentSpread",
      "name": "GroupTableBody_rankField"
    }
  ],
  "type": "JiraJqlFieldWithAliases"
};

(node as any).hash = "27d4e25cfd3c3a4e630c5db59dd935a9";

export default node;
